import http from './http';

export function recordAccess(accessUrl, referrerUrl) {
  return http.post('/access-records', { accessUrl, referrerUrl });
}
